import { useEffect } from "react";
import i18n, { projectLanguageToLng, getUserDefaultLng, setUserDefaultLng } from ".";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";

// The document's `lang` follows the project too: without it the browser picks CJK glyphs by
// its own locale, and Japanese text renders with Chinese character forms.
export const applyLanguage = (lng: string) => {
  if (i18n.language !== lng) void i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
};

export function useProjectLanguageSync(projectLanguage?: string | null) {
  useEffect(() => {
    applyLanguage(projectLanguageToLng(projectLanguage));
  }, [projectLanguage]);

  useEffect(() => {
    return () => applyLanguage(getUserDefaultLng());
  }, []);
}

export function useUserLanguageSync() {
  const { uiLanguage } = useMeStore();

  useEffect(() => {
    if (!uiLanguage) return;
    const lng = projectLanguageToLng(uiLanguage);
    setUserDefaultLng(lng);
    applyLanguage(lng);
  }, [uiLanguage]);
}
